import React, {useState} from "react";
const numeral = require('numeral');

export default ({product, addToCart}) => {

    const [initQuantity, setInitQuantity] = useState(product.in_order);
    const [quantity, setQuantity] = useState(product.in_order);
    const [dirty, setDirty] = useState(false);

    return <tr>
        <td>{product.sku}</td>
        <td>{product.title}</td>
        <td>{product.available_stock}</td>
        <td>{numeral(product.price).format('$0.00')} EXCL GST</td>
        <td>
            <div className="cart-count-align">
                <input type="number"
                       value={quantity}
                       onChange={(e) => {
                            const input = e.target;
                            let value = parseInt(input.value);
                            if (value > product.available_stock) {
                                value = product.available_stock;
                            }
                            if (value < 0) {
                                value = 0;
                            }
                            setQuantity(value);
                            setDirty(initQuantity !== value);
                        }} />
                <a onClick={(e) => {
                    e.preventDefault();
                    addToCart(product.id, quantity);
                    setInitQuantity(quantity);
                    setDirty(false);
                    return false;
                }} className={dirty ? 'btn' : 'btn btn--blue--border'}>
                    {initQuantity && quantity < initQuantity ? 'Remove' : 'Add to cart'}
                </a>
            </div>
        </td>
    </tr>;

}
